import React, { useState } from 'react';
import { useScope } from '../scopeContext';

const NEW_SENTINEL = '__new__';

interface Props {
  value: string | null;
  onChange: (id: string | null) => void;
  /** Label shown before the select. */
  label?: string;
  /** When true, show an "All projects" option (null value). Default: false. */
  allowNull?: boolean;
}

const ProjectSelect: React.FC<Props> = ({
  value,
  onChange,
  label = 'Project:',
  allowNull = false,
}) => {
  const { projectIds } = useScope();
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const allIds = [...new Set([...(value ? [value] : []), ...projectIds])].sort();

  const selectValue = showInput ? NEW_SENTINEL : (value ?? '');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    if (val === NEW_SENTINEL) {
      setShowInput(true);
    } else {
      setShowInput(false);
      onChange(val || null);
    }
  };

  const confirm = () => {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    onChange(trimmed);
    setShowInput(false);
    setInputValue('');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <label style={{ fontSize: 13, color: '#555', whiteSpace: 'nowrap' }}>{label}</label>
      <select
        value={selectValue}
        onChange={handleChange}
        style={{
          padding: '4px 8px',
          borderRadius: 4,
          border: '1px solid #ddd',
          fontSize: 13,
          minWidth: 220,
        }}
      >
        {allowNull && <option value="">All projects</option>}
        {allIds.map((id) => (
          <option key={id} value={id}>{id}</option>
        ))}
        <option value={NEW_SENTINEL}>[New project]</option>
      </select>
      {showInput && (
        <>
          <input
            autoFocus
            type="text"
            placeholder="Enter project UUID"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') confirm();
              if (e.key === 'Escape') setShowInput(false);
            }}
            style={{
              padding: '4px 8px',
              border: '1px solid #ddd',
              borderRadius: 4,
              fontSize: 13,
              width: 280,
            }}
          />
          <button
            type="button"
            onClick={confirm}
            className="button button-primary"
            style={{ padding: '4px 10px', fontSize: 13 }}
          >
            Set
          </button>
          <button
            type="button"
            onClick={() => setShowInput(false)}
            className="button"
            style={{ padding: '4px 10px', fontSize: 13 }}
          >
            Cancel
          </button>
        </>
      )}
    </div>
  );
};

export default ProjectSelect;
